export const ReportSwal = {
  install(Vue) {
    let countdownInterval = null

    function clearCountdown() {
      if (countdownInterval) {
        clearInterval(countdownInterval)
        countdownInterval = null
      }
    }

    function parseSeconds(message) {
      const match = message ? message.match(/\d+/) : null
      return match ? parseInt(match[0]) : 60
    }

    Vue.prototype.$reportSwal = function (errorResponse, retryCallback) {
      const text = (errorResponse && errorResponse.data) ? (new TextDecoder('utf-8').decode(errorResponse.data)) : null
      const json = text ? JSON.parse(text) : {}
      const message = (json && json.message) || (json && json.response && json.response.data && json.response.data.message)
      let remaining = parseSeconds(message)

      clearCountdown()

      countdownInterval = setInterval(() => {
        if (remaining > 0) {
          remaining--
          const el = document.getElementById('swal-countdown')
          if (el) el.textContent = remaining
        } else {
          clearCountdown()
        }
      }, 1000)

      this.$swal({
        html: `
          <div style="font-size: 56px; margin-bottom: 8px;">⏳</div>
          <h2 style="font-size: 20px; font-weight: 700; color: #1a1a2e; margin: 0 0 12px;">
            Ҳужжат тайёрланмоқда
          </h2>
          <p style="font-size: 14px; color: #6b7280; margin: 0 0 12px; line-height: 1.6;">
            Илтимос, ҳужжатни навбат билан олинг ва бироздан сўнг қайта уриниб кўринг!
          </p>
          <p style="font-size: 15px; font-weight: 600; color: #e05a2b; margin: 0;">
            Илтимос, <span id="swal-countdown">${remaining}</span> сония кутинг!
          </p>
        `,
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: '🔄 Янгилаш',
        cancelButtonText: 'Ёпиш',
        confirmButtonColor: '#3b82f6',
        cancelButtonColor: '#9ca3af',
        allowOutsideClick: true,
        allowEscapeKey: true,
        customClass: 'swal-waiting-popup'
      }).then((result) => {
        clearCountdown()
        if (result && result.value && typeof retryCallback === 'function') {
          retryCallback()
        }
      })
    }
  }
}
